import { connect } from 'react-redux';

import InfoIconUI from './InfoIconUI';
import { routingActionCreator } from './actions/routingActionCreators';


const mapStateToProps = (state) => {
    const { pathname } = state.routing.locationBeforeTransitions;
    return {
        pathname
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onIconClick: (route) => dispatch(routingActionCreator(route))
    };
};

const InfoIconContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(InfoIconUI);

export default InfoIconContainer;
